import type { FC } from "react";

import {
  type TCardContentProps,
} from "@/ui/components/data-display/Card/Card.config";

export const CardContent: FC<TCardContentProps> = (
  {
    children,
    ...props
  },
) => (
  <div
    data-component="CardContent"
    className="flex flex-col space-x-2 p-4"
    {...props}
  >
    { children }
  </div>
);

CardContent.displayName = "CardContent";
